import { grey } from '@material-ui/core/colors'
import Colors from 'Support/Theme/Colors/Colors'

const EditOrderModalStyles = ({ theme }: any) => ({
  editOrder: {
    padding: theme.spacing(1) * 3,
  },
  row: {
    padding: `0 ${theme.spacing(1) * 3}px`,
  },
  paperClassesInfo: {
    maxHeight: 500,
  },
  infoList: {
    margin: 0,
    padding: 0,
    listStyle: `none`,
    '&>li': {
      fontWeight: 500,
      fontSize: theme.typography.body2.fontSize,
      paddingTop: theme.spacing(1) * 0.5,
      paddingBottom: theme.spacing(1) * 0.5,
    },
  },
  callBoral: {
    color: Colors.boralgreen[500],
  },
  heading: {
    color: Colors.boralgreen[500],
  },
  testingRequired: {
    opacity: 0.5,
    borderBottom: `1px dotted ${theme.palette.grey[`500`]}`,
  },
  phoneInputItem: {
    marginTop: -theme.spacing(1) * 2,
  },
  separator: {
    border: 0,
    height: 1,
    backgroundColor: grey[300],
    width: `100%`,
  },
  reportOpenTCs: {
    marginTop: theme.spacing(1) * 8,
  },
  note: {
    marginTop: theme.spacing(1) * 2,
  },
  finishButton: {
    color: 'white',
  },
})

export default EditOrderModalStyles
